module.exports = __webpack_public_path__ + "media/dashboard/assets/crm/whatsapp-eb43b14d0b2252235319d25f5dc8d464.svg";